import { useState, useEffect, useCallback } from "react";
import { useSession } from "@clerk/clerk-react";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { API_URL } from "constants/index";

export const useUpsellingMetrics = () => {
  const { session } = useSession();
  const [metrics, setMetrics] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchMetrics = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await fetchWithAuth(
        `${API_URL}/rental/metrics/upselling`,
        { method: "GET" },
        session
      );
      const data = await response.json();
      setMetrics(data);
      setError(null);
    } catch (error) {
      console.error("Failed to fetch upselling metrics:", error);
      setError("Failed to load upselling metrics");
    } finally {
      setIsLoading(false);
    }
  }, [session]);

  useEffect(() => {
    if (session) {
      fetchMetrics();
    }
  }, [session, fetchMetrics]);

  return { metrics, isLoading, error, refetch: fetchMetrics };
};
